import {
  FETCH_SUPPORTTYPE_SUCCESS_ACTION,
  FETCH_SUPPORTDETAILS_SUCCESS_ACTION,
  FETCH_SUPPORTHISTORY_SUCCESS_ACTION,
  FETCH_SUPPORTUSERS_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false
};


export default function(state: any = initialState, action: Function) {
  switch (action.type) {

    case FETCH_SUPPORTTYPE_SUCCESS_ACTION:
      return {
        ...state,
        supportTypeList: action.payload.rows,
       
      };

    case FETCH_SUPPORTDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        supportDtlsList: action.payload.rows,
        supportDtlsCount: action.payload.count
      };

    case FETCH_SUPPORTHISTORY_SUCCESS_ACTION:
      return {
        ...state,
        supportHistoryList: action.payload.rows,
        supportHistoryCount: action.payload.count
      };

    case FETCH_SUPPORTUSERS_SUCCESS_ACTION:
      return {
        ...state,
        supportUsersList: action.payload.rows
      };
  
    default:
      return {
        ...state
      };
  }
}
